export default class LimeApi {
    static OrganisationGateway: string = 'organisation_gateway_api';
    static PopulationPulse: string = 'population_pulse_api';
}